import React from 'react';
import {Link} from "react-router-dom";
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {createUser} from "../../creators/signup";

import Icon from "../components/Icon";
import {Button} from "../components/Button";
import pictureLogo from '../../images/logoc.png';
import createLink from "../../libs/createLink";
import {CheckboxInputField} from "../components/FormField";
import Helmet from "react-helmet";
import {config} from "../../config";
import {canonical} from "../../libs/helper";
import illustration from "../../images/pages/signup/6.jpg";
import AskSex from "../components/SignUpInformation/components/AskSex";
import PasswordStrength from "../components/PasswordStrength";
import passwordStrength from "../../libs/passwordStrength";
import classNames from "classnames";

class Signup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            email: "",
            password: "",
            passwordStrengthError:false,
            //newsletter: true,
            gender : 0,
            cgu: false,
            showPassword: false,
            error : false
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.handleBlockSelection = this.handleBlockSelection.bind(this);
    }

    handleBlockSelection(id, type) {
        this.setState({[type]: id});
    }


    // componentDidMount(prevProps) {
    //     console.log(this.props.currentUserError);
    // }

    // componentDidUpdate(prevProps) {
    //     console.log(this.props.currentUserError);
    // }

    onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.state.cgu && this.state.gender !== 0 && !this.state.passwordStrengthError) {
            this.props.createUser({
                username: this.state.username,
                email: this.state.email,
                password: this.state.password,
                //newsletter: this.state.newsletter,
                gender : this.state.gender,
                source : localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_source`) || "voissa"
            });
            this.setState({error : false})
        }
        else{
            this.setState({error : true})
        }

    }

    handlePasswordValidation(e){
        let password = e.target.value;
        let passwordStrengthError = !!password ? !passwordStrength(password).isValid : false;
        this.setState({password, passwordStrengthError});
    }

    render() {

        return (
            <div id="signup">
                <Helmet>
                    <title>{config.preTitle}Inscription{config.postTitle}</title>
                    <link rel="canonical" href={canonical(createLink("signup"), "", "signup")}/>
                </Helmet>
                <div className="black-layer"/>
                <div className="container">
                    <div className="card">
                        <div className="main-wrapper">
                            <img className="voissa-logo" src={pictureLogo} alt={"Voissa logo"}/>
                            {/*<Title heading={"heading-1"} display={"display-1"}>Inscription Voissa</Title>*/}
                            <p className="sub-title">Le plus bel espace de liberté.</p>
                            <form onSubmit={(event) => this.onSubmit(event)}>
                                <div className="input-group">
                                    <input className="bottom-bar-style" value={this.state.username}
                                           onChange={(event) => this.setState({"username": event.target.value})}
                                           required={true} type="text" placeholder="Choisissez un pseudonyme *"/>
                                </div>
                                <div className="input-group">
                                    <input className="bottom-bar-style" value={this.state.email}
                                           onChange={(event) => this.setState({"email": event.target.value})}
                                           required={true} type="email" placeholder="Votre Email *"/>
                                    {this.props.signup.error && this.props.signup.error.errors && this.props.signup.error.errors.email ? <span className="input-error">{this.props.signup.error.errors.email}</span> : null}
                                </div>
                                <div className="input-group password">
                                    <input value={this.state.password}
                                           className={classNames(["bottom-bar-style",{error:this.state.passwordStrengthError}])}
                                           onChange={this.handlePasswordValidation.bind(this)}
                                           required={true} type={this.state.showPassword ? "text" : "password"}
                                           placeholder="Votre mot de passe *"
                                           autoComplete="new-password"/>
                                    <span className={"show-password"}
                                          onClick={() => this.setState({showPassword: !this.state.showPassword})}><Icon
                                        type={this.state.showPassword ? "eye-cut" : "eye"}/></span>
                                </div>
                                {!!this.state.password && <PasswordStrength password={this.state.password}/>}

                                <AskSex gender={this.state.gender} isError={(this.state.error && this.state.gender === 0)} handleBlockSelection={this.handleBlockSelection}/>

                                {/*<CheckboxInputField checked={this.state.newsletter}
                                                    onChange={() => this.setState({newsletter: !this.state.newsletter})}
                                                    label={"Recevoir notre newsletter hebdomadaire"}
                                                    id={"newsletter"}
                                                    htmlFor={"newsletter"}/>*/}
                                <CheckboxInputField checked={this.state.cgu}
                                                    required={true}
                                                    onChange={() => this.setState({cgu: !this.state.cgu})}
                                                    label={<span>J'ai lu et j'accepte <Link to="/cgus">les termes d'utilisation</Link>*</span>}
                                                    id={"terms"}
                                                    htmlFor={"terms"}/>

                                <span className="signup-infos">*Champs obligatoires</span>

                                {this.props.signup && this.props.signup.error && this.props.signup.error.statusCode === 409 && (
                                    <span className="warning">Email ou Login déjà utilisé</span>
                                )}
                                {this.props.signup && this.props.signup.error && this.props.signup.error.statusCode === 400 &&(
                                    <span className="warning">{this.props.signup.error.message}</span>
                                )}
                                <Button
                                    btnType={"submit"}
                                    loading={this.props.signupLoading}
                                    size={"big"}
                                    btnStyle={"primary-reverse"}
                                    content={"Commencez l'aventure Voissa"}/>

                            </form>
                            <div className={"row bottom-infos"}>
                                <Link className={"go-to-signin"} to={createLink("signin")}>J'ai déjà un compte</Link>
                            </div>
                        </div>
                        <div className={"voissa-advantage"}>
                            <div className={"voissa-touch-img"}>
                                <img
                                    src={illustration}
                                    alt={"voissa touch"}/>
                            </div>
                            <div className={"free"}>
                                <div className={"free-wrapper"}>
                                    <div className={"text-icon"}><Icon type={"free"}/> C'EST GRATUIT</div>
                                    <div className={"text-icon"}><Icon type={"incognito"}/> ANONYME</div>
                                    <div className={"text-icon"}><Icon type={"secure"}/> 100% SECURISÉ</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    signup: state.signup,
    signupLoading: state.signup.loading,
    currentUser: state.currentUser.data,
    currentUserInitialized: state.currentUser.initialized,
});


const mapDispatchToProps = (dispatch) => bindActionCreators({
    createUser,
    // fetchCurrentUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Signup);

